import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const Background = styled.div`
  position: relative;
  min-height: 100vh;

  background-color: ${BaSeTheme.colors.defaultColors.black};
  background-repeat: no-repeat;

  ${({ imgBackground }) =>
    css`
      background-image: url(${imgBackground});
    `};
  background-size: cover;
  background-position: center;

  &::before {
    position: fixed;
    content: '';
    width: 100vw;
    height: 100vh;
    display: block;
    top: 0;
    right: 0;
    background: radial-gradient(
      circle at top right,
      ${({ isAuthenticated, primaryColor }) =>
          isAuthenticated ? primaryColor ?? '#175e8b' : primaryColor} -30vh,
      transparent 40vw
    );
  }
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;

  &::before {
    position: fixed;
    content: '';
    width: 100vw;
    height: 100vh;
    display: block;
    bottom: 0;
    left: 0;
    background: radial-gradient(
      circle at bottom left,
      ${({ isAuthenticated, secondaryColor }) =>
          isAuthenticated ? secondaryColor ?? '#5c0936' : '#F5CE60'} -50%,
      transparent 40vw
    );
  }
`;
